import { render, staticRenderFns } from "./OpenBetsTabRow.vue?vue&type=template&id=0a5b1a0c&scoped=true&"
import script from "./OpenBetsTabRow.vue?vue&type=script&lang=js&"
export * from "./OpenBetsTabRow.vue?vue&type=script&lang=js&"
import style0 from "./OpenBetsTabRow.vue?vue&type=style&index=0&id=0a5b1a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b1a0c",
  null
  
)

export default component.exports